import AudioUnit from "./AudioUnit";
import teoria from "teoria";

class Instrument extends AudioUnit {

	scheduleNote(note, time) {
		console.error("Not implemented")
	}


	_getNote(tonic, key, octave, note) {
		var scale = teoria.note(tonic + octave).scale(key);
		var len = scale.scale.length;

		var n = scale.get((note%len)+1);

		for(var i = 0, times = Math.floor(note/len); i < times; i++) {
			n.transpose(teoria.interval("P8"));
		}

		return n;
	}

	getNoteFrequency(tonic, key, octave, note) {
		return this._getNote(tonic, key, octave, note).fq();
	}

	getNoteChord(tonic, key, octave, note, chord) {
		return this._getNote(tonic, key, octave, note).chord(chord).notes().map((note) => note.fq());
	}

	getNotesNames(tonic, key) {
		var scale = teoria.note(tonic + 1).scale(key);

		var len = scale.scale.length;

		scale = scale.notes().map(note => {
			return note.scientific().replace(/([\d])/gi, "");
		});

		if(len < 14) {
			scale.push(...scale);
		}

		var notes = [];
		for(var i = 0; i < 14; i++) {
			notes.push(scale[i%len])
		}

		return notes;
	}

}

export default Instrument;
